import { Gem, CalendarCheck, ShieldCheck, HeartHandshake } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const items = [
  {
    icon: Gem,
    title: "Quality Materials",
    body: "We build with durable, proven materials — no shortcuts, no cheap substitutes that fail down the line.",
  },
  {
    icon: CalendarCheck,
    title: "On-Time Delivery",
    body: "Realistic schedules and disciplined project management mean your renovation finishes when we said it would.",
  },
  {
    icon: ShieldCheck,
    title: "Licensed & Insured",
    body: "Fully licensed and insured across Florida and Virginia — protected work you can sign off on with confidence.",
  },
  {
    icon: HeartHandshake,
    title: "Personalized Approach",
    body: "Direct communication with the people doing the work. Your priorities shape every decision on site.",
  },
];

export default function WhyUs() {
  return (
    <section id="why" className="relative py-24 md:py-36 bg-brand-footer" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <Reveal>
            <Overline>Why GBuildersLLC</Overline>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-brand-text leading-[1.02]">
              The difference is in how we work.
            </h2>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-brand-hi border border-brand-hi rounded-sm overflow-hidden">
          {items.map((it, i) => (
            <Reveal key={it.title} delay={0.06 * i}>
              <div className="group h-full bg-brand-navy p-8 md:p-10 transition-colors hover:bg-brand-surface" data-testid={`why-item-${i}`}>
                <div className="w-14 h-14 flex items-center justify-center border border-brand-hi rounded-sm mb-8 text-brand-orange group-hover:border-brand-orange transition-colors">
                  <it.icon className="w-6 h-6" strokeWidth={1.5} />
                </div>
                <h3 className="font-heading text-xl font-semibold text-brand-text">{it.title}</h3>
                <p className="mt-4 text-brand-muted leading-relaxed text-sm md:text-base">{it.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
